const action = () => {
    var date = new Date(),
    y = date.getFullYear(),
    m = (date.getMonth() + 1).toString().padStart(2, '0'),
    d = date.getDate().toString().padStart(2, '0'),
    lastYear = date.getFullYear() - 1

    var firstDay = m + "/" + d + "/"+ lastYear ;
    var todayDate = m + "/" + d + "/" + y;

    let start_date = y-1 + "-" + m + "-" + d;
    let end_date = y + "-" + m + "-" + d;
    
    if(m == '02' && d > 28){
        firstDay = m + "/" + 28 + "/"+ lastYear ;
        start_date = y-1 + "-" + m + "-" + 28;
    }

    let actionTable = "";
    let publisherId = "";

    const actionDt = () => {
        actionTable = $("#action_dt").DataTable({
            responsive: true,
            processing: true,
            serverSide: true,
            //ordering: true,
            searching: true,
            order: [[3, "desc"]],
            // "sProcessing": "Please wait...",
            language: {
                processing:
                    '<i class="myspinner fa fa-spinner fa-spin" style="font-size:24px;color:rgb(75, 183, 245);"></i>',
            },
            // "pagingType": "full_numbers",
            pageLength: 10,
            ajax: {
                url: "/action/listing",
                type: "POST",
                datatype: "json",
                data: function (data) {
                    data.startDate = start_date;
                    data.endDate = end_date;
                    data.publisherId = publisherId;
                },
            },
            columns: [
                { data: "user_id", name: "user.name" },
                { data: "publisher_id", name: "user.name" },
                { data: "business_name", name: "actions.business_name" },
                // { data: "qty", name: "actions.qty" , className: "text-end"},
                // { data: "amount", name: "actions.amount" },
                { data: "order_date", name: "actions.created_at" },
                { data: "action", name: "actions.action"},
            ],
            // footerCallback: function (row, data, start, end, display) {
            //     var api = this.api();
            //     var total = 0;
            //     var pageTotal;
            //     // Remove the formatting to get integer data for summation
            //     var intVal = function (i) {
            //         return typeof i === 'string' ? i.replace(/[\$,]/g, '') * 1 : typeof i === 'number' ? i : 0;
            //     };

            //     // Total over all pages
            //     total = api
            //         .column(3)
            //         .data()
            //         .reduce(function (a, b) {
            //             return intVal(a) + intVal(b);
            //         }, 0);

            //     // Total over this page
            //     pageTotal = api
            //         .column(3, { page: 'current' })
            //         .data()
            //         .reduce(function (a, b) {
            //             return intVal(a) + intVal(b);
            //         }, 0);

            //     // Update footer
            //    // $(api.column(3).footer()).html('$' + pageTotal + ' ( $' + total + ' total)');
            //    $(api.column(3).footer()).html('Total : '+total);
            // },
        });
    };

    if ($("#action_dt").length > 0) {
        $("#publisherId").select2();

        actionDt();
        $(function () {
            $('input[name="daterange"]').daterangepicker(
                {
                    // autoApply: true,
                    startDate: firstDay,
                    endDate: todayDate,
                },
                function (start, end, label) {
                    start_date = start.format("YYYY-MM-DD");
                    end_date = end.format("YYYY-MM-DD");
                    actionTable.draw();
                }
            );
        });

        $("#publisherId").on("select2:select", function (e) {
            publisherId = $(this).val();
            actionTable.draw();
        });
    }
}
export default action;